import React from "react";
import { Dialog, useMediaQuery } from "@mui/material";

export default function ResponsiveDialog({ children, PaperProps, ...props }) {
  const isMobile = useMediaQuery("(max-width:767.95px)");

  return (
    <Dialog
      fullScreen={isMobile}
      fullWidth
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: "calc(100vw - 24px)" },
          maxWidth: { xs: "100%", sm: "calc(100vw - 24px)", md: "min(900px, calc(100vw - 48px))" },
          m: { xs: 0, sm: 1.5, md: 2 },
          borderRadius: { xs: 0, sm: 2 },
          maxHeight: { xs: "100dvh", sm: "90vh" },
          overflowY: "auto"
        },
        ...PaperProps
      }}
      {...props}
    >
      {children}
    </Dialog>
  );
}
